import translations from '../translations';

// 获取翻译文本
export const t = (key, language = 'ja') => {
  // 如果语言不支持，默认使用日语
  const lang = translations[language] ? language : 'ja';
  const keys = key.split('.');
  let value = translations[lang];
  
  for (const k of keys) {
    if (value && value[k] !== undefined) {
      value = value[k];
    } else {
      // 如果找不到翻译，返回key本身
      console.warn(`Translation key not found: ${key} for language: ${lang}`);
      return key;
    }
  }
  
  return value;
};

// 获取当前语言的翻译
export const useTranslation = () => {
  const { language } = require('../contexts/LanguageContext').useLanguage?.() || { language: 'ja' };
  
  return {
    t: (key) => t(key, language),
    language
  };
};

export default t;
